import { DateSelectorOptions } from "../models";

export const LeaveNowOption: DateSelectorOptions = {
    id: 'leaveNow',
    label: 'routeForm.leaveNow'
}

export const leaveAtOption: DateSelectorOptions = {
    id: 'leaveAt',
    label: 'routeForm.leaveAt'
}

export const ArriveAtOption: DateSelectorOptions = {
    id: 'arriveAt',
    label: 'routeForm.arriveAt'
}

export const DATE_SELECTOR_OPTIONS: DateSelectorOptions[] = [ LeaveNowOption, leaveAtOption, ArriveAtOption]
